var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup26111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2609548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 1H9C7.93913 1 6.92172 1.42143 6.17157 2.17157C5.42143 2.92172 5 3.93913 5 5V37C5 38.0609 5.42143 39.0783 6.17157 39.8284C6.92172 40.5786 7.93913 41 9 41H33C34.0609 41 35.0783 40.5786 35.8284 39.8284C36.5786 39.0783 37 38.0609 37 37V11L27 1Z",
    fill: "#D9E4EC",
    stroke: "#024776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 1V9C25 10.0609 25.4214 11.0783 26.1716 11.8284C26.9217 12.5786 27.9391 13 29 13H37",
    stroke: "#024776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2609547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2609546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2_2",
    d: "M18.14 47.1429L14.7515 43.7515",
    stroke: "#024776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.85714 45.7143C13.8857 45.7143 16.7143 42.8857 16.7143 37.8571C16.7143 32.8286 13.8857 30 8.85714 30C3.82857 30 1 32.8286 1 37.8571C1 42.8857 3.82857 45.7143 8.85714 45.7143Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.85714 45.7143C13.8857 45.7143 16.7143 42.8857 16.7143 37.8571C16.7143 32.8286 13.8857 30 8.85714 30C3.82857 30 1 32.8286 1 37.8571C1 42.8857 3.82857 45.7143 8.85714 45.7143Z",
    stroke: "#024776",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26111);
export default __webpack_public_path__ + "static/media/Group 2611 (1).78cc349201a738275ee6d2244a04f265.svg";
export { ForwardRef as ReactComponent };